import {Empty} from 'antd';
import {PropsWithChildren} from 'react';

import {Spinner} from '../../layout/spinner/spinner';
import {AlertFallback} from '../alert-fallback/alert-fallback';

type PropsType = {
    isLoading?: boolean;
    isEmpty?: boolean;
    isError?: boolean;
};

export function DataLoadingSwitch({
    isLoading,
    isEmpty,
    isError,
    children,
}: PropsWithChildren<PropsType>): JSX.Element | null {
    if (isEmpty) {
        return <Empty />;
    }

    if (isLoading) {
        return <Spinner />;
    }

    if (isError) {
        return <AlertFallback />;
    }

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
}
